/*
We're constantly improving the code you see.
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from 'react'

export const RectangleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M15 0.579956H5C3.67392 0.579956 2.40215 1.10674 1.46447 2.04442C0.526784 2.9821 0 4.25387 0 5.57996V15.58C0 16.906 0.526784 18.1778 1.46447 19.1155C2.40215 20.0532 3.67392 20.58 5 20.58H15C16.3261 20.58 17.5979 20.0532 18.5355 19.1155C19.4732 18.1778 20 16.906 20 15.58V5.57996C20 4.25387 19.4732 2.9821 18.5355 2.04442C17.5979 1.10674 16.3261 0.579956 15 0.579956ZM18 15.58C18 16.3756 17.6839 17.1387 17.1213 17.7013C16.5587 18.2639 15.7956 18.58 15 18.58H5C4.20435 18.58 3.44129 18.2639 2.87868 17.7013C2.31607 17.1387 2 16.3756 2 15.58V5.57996C2 4.78431 2.31607 4.02125 2.87868 3.45864C3.44129 2.89603 4.20435 2.57996 5 2.57996H15C15.7956 2.57996 16.5587 2.89603 17.1213 3.45864C17.6839 4.02125 18 4.78431 18 5.57996V15.58Z"
        fill="black"
      />
    </svg>
  )
}
